<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="pvd-container p-xsmall-top">
    <ul class="xsmall no-bullets">
      <li class="color-neutral">
        <VueShowdown
          :extensions="[formatMarkdown]"
          :markdown="pd_content.rc_page_disclosure_youth.paragraph2"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import dataHelper from '../mixins/dataHelper';

export default {
  name: 'YouthDisclosureComponent',
  mixins: [
    dataHelper,
  ],
};
</script>
<style scoped>
 ul.no-bullets {
  list-style-type: none; /* Remove bullets */
  padding: 0; /* Remove padding */
  margin: 0; /* Remove margins */
}
</style>
